import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import CancelOutlined from "@material-ui/icons/Clear";
import PswdShown from "@material-ui/icons/Visibility";
import PswdHidden from "@material-ui/icons/VisibilityOff";
import Joi from "joi";
import "../styles.css";
import axiosInstance from "../../utils/config";

function NewUser(props) {
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState({
      status: false,
      message: null,
    }),
    [isPasswordShown, setIsPasswordShown] = useState(false),
    changePswdVisibility = (action) => {
      action === "hide" ? setIsPasswordShown(false) : setIsPasswordShown(true);
    };
  const [categories, setCategories] = useState([]);
  const [userInfo, setUserInfo] = useState({
    Names: "",
    Email: "",
    Password: "",
    BusinessCategory: [],
  });

  const [formErrors, setFormErrors] = useState({
    namesError: "",
    emailError: "",
    passwordError: "",
    businessCategoryError: "",
  });

  const schemaMap = {
    Names: Joi.string().required().max(40).min(5).label("Fullname field"),
    Password: Joi.string().required().max(25).min(6).label("Password field"),
    Email: Joi.string()
      .max(100)
      .min(5)
      .required()
      .email({ tlds: { allow: false } })
      .label("Email field"),
    BusinessCategory: Joi.array().required(),
  };
  useEffect(() => {
    document.title = "Register | Ski Design";
    axiosInstance
      .get("/categories")
      .then((data) => {
        setCategories(data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const schema = Joi.object(schemaMap);

  const handleChange = () => {
      const options = { abortEarly: false };
      const { error } = schema.validate(userInfo, options);
      if (!error) setSuccessMsg({ status: true, message: "" });
      else setSuccessMsg({ status: false, message: "" });
    },
    handleSubmit = (e) => {
      e.preventDefault();
      setSubmitting(true);
      const options = { abortEarly: false };
      const { error } = schema.validate(userInfo, options);
      if (error) {
        const errors = {};
        for (let item of error.details) {
          errors[item.path[0]] = item.message;
        }
        setFormErrors({
          namesError: errors.Names,
          emailError: errors.Email,
          passwordError: errors.Password,
          businessCategoryError: errors.BusinessCategory,
        });
        setSubmitting(false);
      } else {
        const { Names, Email, Password, BusinessCategory } = userInfo;
        setSuccessMsg({ status: null, message: null });
        setFormErrors({
          namesError: "",
          emailError: "",
          passwordError: "",
          businessCategoryError: "",
        });
        axiosInstance
          .post("/register", {
            Names,
            Email,
            Password,
            BusinessCategory: [],
          })
          .then((data) => {
            setSuccessMsg({
              status: true,
              message: "The New User was successfully created.",
            });
            setSubmitting(false);
            setFormErrors({
              namesError: "",
              emailError: "",
              passwordError: "",
              businessCategoryError: "",
            });
            setTimeout(() => {
              props.setPopupDisplay("none");
            }, 2000);
            window.location.reload();
          })
          .catch((err) => {
            setFormErrors({
              namesError:
                "Error. Email may be already taken or may be you are offline..",
              emailError: "",
              passwordError: "",
              businessCategoryError: "",
            });
            if (err.response) {
              setSuccessMsg({
                status: false,
                message: err.response.data,
              });
              setSubmitting(false);
            }
          });
      }
    };

  const { display } = props;

  const hidePopup = () => {
    props.setPopupDisplay("none");
    document.body.style.overflow = "auto";
    setUserInfo({
      Names: "",
      Email: "",
      Password: "",
      BusinessCategory: [],
    });
  };

  return (
    <div className="NewUserPopup" style={{ display }}>
      <div
        className="PopupTransparentBg"
        id="PopupTransparentBg"
        onClick={() => hidePopup()}
      ></div>
      <div className="NewUserContent">
        <div className="NewUserHeader">
          <Button onClick={() => hidePopup()} title="Close">
            <CancelOutlined />
          </Button>
        </div>
        <form action="/" method="POST" autoComplete="off">
          {successMsg.message && successMsg.status ? (
            <div className="alert alert-success text-center" role="alert">
              {successMsg.message}
            </div>
          ) : (
            ""
          )}
          {formErrors.namesError ? (
            <p className="my-3 error">{formErrors.namesError}</p>
          ) : formErrors.emailError ? (
            <p className="my-3 error">{formErrors.emailError}</p>
          ) : formErrors.passwordError ? (
            <p className="my-3 error">{formErrors.passwordError}</p>
          ) : formErrors.businessCategoryError ? (
            <p className="my-3 error">{formErrors.businessCategoryError}</p>
          ) : (
            ""
          )}
          <div style={{ position: "relative" }}>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              required
              value={userInfo.names}
              onChange={(e) => {
                setUserInfo({ ...userInfo, Names: e.target.value });
                handleChange();
              }}
            />
            <input
              type={isPasswordShown ? "text" : "password"}
              name="userPassword"
              placeholder="Password"
              required
              value={userInfo.password}
              onChange={(e) => {
                setUserInfo({ ...userInfo, Password: e.target.value });
                handleChange();
              }}
            />
            {isPasswordShown ? (
              <PswdShown
                titleAccess="Hide password"
                className="pswdShowHide"
                onClick={() => changePswdVisibility("hide")}
              />
            ) : (
              <PswdHidden
                titleAccess="Show password"
                className="pswdShowHide"
                onClick={() => changePswdVisibility("show")}
              />
            )}
          </div>
          <div>
            <input
              type="email"
              name="userEmail"
              placeholder="Email"
              required
              value={userInfo.email}
              onChange={(e) => {
                setUserInfo({ ...userInfo, Email: e.target.value });
                handleChange();
              }}
            />
            <select
              name="userCategory"
              required
              onChange={(e) => {
                setUserInfo({
                  ...userInfo,
                  BusinessCategory: [e.target.value],
                });
                handleChange();
              }}
              defaultValue=""
            >
              <option value="" disabled>
                Choose Business Category
              </option>
              {categories.map((category, index) => (
                <option value={category._id} key={index}>
                  {category.categoryName}
                </option>
              ))}
            </select>
          </div>
          <div>
            <input
              type="submit"
              onClick={handleSubmit}
              value="Add Client"
              // disabled={!successMsg.status}
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewUser;
